import { GetMeleeStageImage } from "./profileLoader";
import { Image } from "semantic-ui-react";
import StatsTable from "./components/statsTable";
import { sortByWinAndLoss } from "./utils";
import { useMeleeContext } from "draft/context/MeleeContextProvider";

type Props = {
    currentPlayerName: string;
    games: any;
};

const removedStages = [
    "Corneria",
]

const StageTable = ({ currentPlayerName, games }: Props) => {
    const meleeContext = useMeleeContext();
    const preferredPack = meleeContext?.draftOptions.stagePack;

    var stages: { [key: string]: { win_count: number; lose_count: number } } = {};

    for (var key in games) {
        var game = games[key];

        if (!game.stage || removedStages.includes(game.stage)) {
            continue;
        }

        var stage = game.stage;

        var currentPlayerTeam = null;

        // Check if the current player is in team_blue
        for (var player in game.team_blue) {
            if (player === currentPlayerName) {
                currentPlayerTeam = "blue";
                break;
            }
        }

        // Check if the current player is in team_red
        if (!currentPlayerTeam) {
            for (const player in game.team_red) {
                if (player === currentPlayerName) {
                    currentPlayerTeam = "red";
                    break;
                }
            }
        }

        if (stage in stages) {
            stages[stage].win_count += game.winner.toLowerCase() === currentPlayerTeam ? 1 : 0;
            stages[stage].lose_count += game.winner.toLowerCase() === currentPlayerTeam ? 0 : 1;
        } else {
            stages[stage] = {
                win_count: game.winner.toLowerCase() === currentPlayerTeam ? 1 : 0,
                lose_count: game.winner.toLowerCase() === currentPlayerTeam ? 0 : 1,
            };
        }
    }

    const sortedStages = sortByWinAndLoss(stages);

    if (sortedStages.length === 0) {
        return <div></div>
    }

    return (
        <StatsTable header={"Stages"} leftColumn={"Stage"}>
            {sortedStages.map(([stage, stats]) => (
                <tr key={stage}>
                    <td style={{ textAlign: "left" }}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "1em",
                            }}
                        >
                            <Image
                                src={GetMeleeStageImage(stage, preferredPack)}
                                alt={stage}
                                size="tiny"
                            />
                            <p>
                                {stage}
                            </p>
                        </div>
                    </td>
                    <td>{stats.win_count}</td>
                    <td>{stats.lose_count}</td>
                    <td>
                        {(
                            (stats.win_count /
                                (stats.win_count + stats.lose_count)) *
                            100
                        ).toFixed(0)}
                        %
                    </td>
                </tr>
            ))}
        </StatsTable>
    )
}

export default StageTable;